import StateControllerBase from "@/store/stateControllerBase";


class Actions extends StateControllerBase {
  setCurrentPage({ commit }, currentPageIndex) {
    commit("setCurrentPage", currentPageIndex);
  }
}

export default (new Actions).asPlainObject();